<template>
  <div class="modal-overlay">
    <div class="context">

      <div class="review-logo-container">
        <img :src="reviewImage" alt="Image icon"/>
      </div>

      <p>Do you want to {{ verb }} this {{ subject }}?</p>
      <h6>If Yes, add comments below</h6>

      <div class="comment-section">
        <h4>Comments</h4>
        <textarea v-model="reviewComment" placeholder="For multiple comments, press the enter key"></textarea>
        <p class="error-message" v-if="reviewError">Review comment is required and should be greater than 3 characters</p>
      </div>

      <div class="buttons">
        <button @click="modalAction('cancel')">Cancel</button>
        <button @click="modalAction('confirm')">Confirm</button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewDecisionModal',
  props: ['verb', 'subject', 'reviewImage'],
  data() {
    return {
      reviewComment: null,
      reviewError: false
    };
  },
  methods: {
    modalAction(value) {
      if (value === 'confirm' && this.reviewComment && this.reviewComment.length > 3 ) {
        this.reviewError = false;
        this.$emit('modalAction', {value: value, reviewComment: this.reviewComment});
      } else if (value === 'cancel') {
        this.reviewError = false;
        this.$emit('modalAction', {value: value});
      } else {
        this.reviewError = true;
      }
    },
  },
};
</script>

<style scoped>
  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 20;
    background: rgba(20, 20, 20, 0.83);
    display: flex;
    flex-direction: column;
  }
  .modal-overlay .context {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 21;
    width: 100%;
    height: 100%;
    background: var(--white);
    max-width: 787px;
    max-height: 990px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 0;
    overflow-y: scroll;
  }
  .modal-overlay .context::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .modal-overlay .context {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
  .modal-overlay .context .review-logo-container {
    margin-top: 60px;
    margin-bottom: 40px;
  }
  .modal-overlay .context .review-logo-container img {
    min-height: 200px;
    min-width: 200px;
  }
  .modal-overlay .context p {
    font-family: 'montserrat';
    font-style: normal;
    font-weight: 800;
    font-size: 24px;
    line-height: 29px;
    color: var(--black);
    margin-bottom: 50px;
    text-align: center;
  }
  .modal-overlay .context h6 {
    font-family: 'montserrat';
    font-style: normal;
    font-weight: normal;
    font-size: 19px;
    line-height: 23px;
    text-align: center;
    color: #707070;
  }
  .modal-overlay .context .comment-section {
    width:80%;
    margin-top: 60px;
  }
  .modal-overlay .context .comment-section h4 {
    font-family: 'montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 21px;
    color: #707070;
    margin-bottom: 15px;
  }
  .modal-overlay .context .comment-section textarea {
    width: 100%;
    height: 150px;
    background: var(--white);
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    border-radius: 5px;
    resize: none;
    outline: none;
    padding: 12px;
    color: #707070;
  }
  .modal-overlay .context .comment-section .error-message {
    color: tomato;
    font-size: 12px;
  }
  .buttons {
    display: flex;
    justify-content: right;
    margin-top: 30px;
    width: 80%;
  }
  .modal-overlay .context .buttons > button {
    border-radius: 5px;
    padding: 15px 50px;
    font-weight: 800;
  }
  .modal-overlay .context .buttons :nth-child(2) {
    /* left: 804px;
    top: 725px; */
    background: var(--colorPrimary);
    box-shadow: 0px 9px 29px rgba(26, 107, 158, 0.1);
    color: var(--white);
  }
  .modal-overlay .context .buttons :nth-child(1) {
    /* left: 988px;
    top: 725px; */
    color: #252525;
    box-sizing: border-box;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);
    margin-right: 40px;

  }
</style>
